import { FormikTextField, type FormikTextFieldProps } from "@octopus-energy/coral/formik"
import { useTranslations } from "next-intl"

type EmailFieldProps = Omit<FormikTextFieldProps, "type" | "label" | "name"> & {
    label?: FormikTextFieldProps["label"]
    name?: FormikTextFieldProps["name"]
}

export function EmailField(props: EmailFieldProps) {
    const t = useTranslations("EmailField")

    return (
        <FormikTextField
            {...props}
            type="email"
            label={props.label ?? t("email")}
            name={props.name ?? "email"}
        />
    )
}

EmailField.messages = ["EmailField"] as const
